import React from 'react';
import PropTypes from 'prop-types';
import EditableCheckbox from 'components/forms/editableCheckbox';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class UserAccess extends React.Component {
  static displayName = 'UserAccess';

  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    userType: PropTypes.shape({
      purchaseHistory: PropTypes.bool,
      detailedReporting: PropTypes.bool,
      dashboard: PropTypes.bool,
    }),
    onPermissionChange: PropTypes.func,
    title: PropTypes.string,
    hideSecondPermission: PropTypes.bool,
  };

  state = {};

  render() {
    const {
      canEditPosDashboard,
      canEditPurchaseHistory,
      hideSecondPermission,
      isAdmin,
      onPermissionChange,
      title,
      userType,
    } = this.props;
    let {formatMessage} = this.props.intl;

    return (
      <div className="user-access">
        <div className="header">
          {title}
        </div>
        {
          isAdmin ?

            <div className="permissions read-only" >
              <EditableCheckbox editMode={false} value={true} onChange={() => {}}>
                <FormattedMessage id="integrations.customer.account.purchase" />
                <ToolTip title={formatMessage({id: 'integrations.customer.account.description'})}
                           position={tooltipPositions.rightTop} iconOnly/>
              </EditableCheckbox>
              <EditableCheckbox editMode={false} value={true} onChange={() => {}}>
                <FormattedMessage id="integrations.cumulative.reports.csv" />
                <ToolTip title={formatMessage({id: 'integrations.cumulative.reports.description'})}
                           position={tooltipPositions.rightTop} iconOnly/>
              </EditableCheckbox>
              <EditableCheckbox editMode={false} value={true} onChange={() => {}}>
                <FormattedMessage id="integrations.pos.dashboard.tiles" />
                <ToolTip title={formatMessage({id: 'integrations.pos.dashboard.description'})}
                           position={tooltipPositions.rightTop} iconOnly/>
              </EditableCheckbox>
            </div>                        :

            <div className="permissions" >
              <EditableCheckbox dataKey='purchaseHistory' editMode={canEditPurchaseHistory} value={userType.purchaseHistory} onChange={onPermissionChange} withoutHangingIndent>
                <FormattedMessage id="integrations.customer.account.purchase" />
                <ToolTip title={formatMessage({id: 'integrations.customer.account.description'})}
                           position={tooltipPositions.rightTop} iconOnly/>
              </EditableCheckbox>
              {hideSecondPermission ? null :
              <EditableCheckbox dataKey='detailedReporting' editMode={true} value={userType.detailedReporting} onChange={onPermissionChange} withoutHangingIndent>
                <FormattedMessage id="integrations.cumulative.reports.csv" />
                <ToolTip title={formatMessage({id: 'integrations.cumulative.reports.description'})}
                             position={tooltipPositions.rightTop} iconOnly/>
              </EditableCheckbox>
                }
              <EditableCheckbox dataKey='dashboard' editMode={canEditPosDashboard} value={userType.dashboard} onChange={onPermissionChange} withoutHangingIndent>
                <FormattedMessage id="integrations.pos.dashboard.tiles" />
                <ToolTip title={formatMessage({id: 'integrations.pos.dashboard.description'})}
                           position={tooltipPositions.rightTop} iconOnly/>
              </EditableCheckbox>
            </div>

        }
      </div>
    );
  }
}

export default injectIntl(UserAccess);
